import { ApiConnection } from 'src/app/shared/decorators/@ApiConnection.decorator';
import { DataSource } from "@angular/cdk/collections";
import { IApiInvestigationMetricsFilter, IApiInvestigationTimelogConnection, IApiInvestigationTimelog } from 'src/app/shared/modules/graphql/types/types';
import { InvestigationTimelogService } from './investigation-timelog.service';
import { NefcoPagedDataSource } from 'src/app/shared/helpers/nefco-data-source.class';

export class InvestigationTimelogDatasource extends NefcoPagedDataSource<IApiInvestigationTimelog, InvestigationTimelogService, IApiInvestigationTimelogConnection> implements DataSource<IApiInvestigationTimelog> {
  @ApiConnection()
  public load(filters: IApiInvestigationMetricsFilter[] = []): Promise<IApiInvestigationTimelogConnection> {
    return this.service.get(filters, this.listPage).toPromise();
  }
}
